import { useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';

// Module 19 (BL-380) G0 - is the Events pack on for the signed-in user's organization?
// One database question, two keys: the organization holds the events.vertical_pack capability AND one of its entities
// has industry_vertical = 'Events' (public.events_pack_enabled()). Platform super-admins pass the capability test
// everywhere, so the entity key is what keeps Events out of other tenants.
export default function useEventsPack(userId) {
    const [state, setState] = useState({ enabled: false, loading: Boolean(userId) });

    useEffect(() => {
        let active = true;
        if (!userId) {
            setState({ enabled: false, loading: false });
            return () => { active = false; };
        }
        setState((previous) => ({ enabled: previous.enabled, loading: true }));
        Promise.resolve(supabaseClient.rpc('events_pack_enabled'))
            .then(({ data, error }) => {
                if (active) setState({ enabled: !error && data === true, loading: false });
            })
            .catch(() => {
                if (active) setState({ enabled: false, loading: false });
            });
        return () => { active = false; };
    }, [userId]);

    return state;
}
